import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownDirective } from './dropdown.directive';
import { ImageLibraryService } from './imagelibrary.service';
import { LibraryPipe } from '../pipes/library.pipe';
import { ImageLibraryComponent } from '../image-library/image-library.component';
import { BrowserModule } from '@angular/platform-browser';
import { FileDropModule } from 'ngx-file-drop/lib/ngx-drop';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ParticaComponent } from './partica/partica.component';
import { SafeHtmlPipe } from '../pipes/safehtml.pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PropertySearchComponent } from './property-search/property-search.component';
import { Select2Module } from 'ng2-select2';
@NgModule({
    declarations: [
        DropdownDirective,
        ImageLibraryComponent,
        LibraryPipe,
        ParticaComponent,
        SafeHtmlPipe,
        PropertySearchComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        FileDropModule,
        LoadingModule,
        ReactiveFormsModule,
        InfiniteScrollModule,
        Select2Module
    ],
    providers: [
        ImageLibraryService
    ],
    exports: [
        CommonModule,
        DropdownDirective,
        ImageLibraryComponent,
        ParticaComponent,
        LibraryPipe,
        SafeHtmlPipe,
        InfiniteScrollModule,
        PropertySearchComponent,
        Select2Module
    ]
})

export class SharedModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts